export default function messageClient(phone, name) {
  if (!phone || !name) {
    return null;
  }

  const message = `Olá, ${name}! Vi seu perfil no FlameHot e gostaria de conversar.`;
  const url = `https://wa.me/${phone?.replace(
    /\D/g,
    ''
  )}?text=${encodeURIComponent(message)}`;

  return url;
}
